import React from 'react';

import { Color } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';

import './dot.scss';

export interface IDot extends IComponent {
  isBlinking?: boolean;
}

const classNames = (color: Color, isBlinking = false) =>
  makeClassNames({
    dot: ['dot', `dot--bg-color-${color}`, isBlinking && `dot--blinking`],
    wrapper: 'dot--wrapper',
  });

const Dot = ({ color = 'red-light', isBlinking = false }: IDot) => {
  const cn = classNames(color, isBlinking);

  return (
    <div className={cn.wrapper}>
      <span className={cn.dot} />
    </div>
  );
};

export default Dot;
